import React from "react";

class WhitepaperSectionHeader extends React.Component {
  render() {
    return <h1 className="landing-body-content-header landing-body-content-header-whitepaper">Whitepaper</h1>;
  }
}

export default WhitepaperSectionHeader;
